import { render, staticRenderFns } from "./PassengerEditView.vue?vue&type=template&id=ca419cf0"
import script from "./PassengerEditView.vue?vue&type=script&lang=ts"
export * from "./PassengerEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports